import { ValidateType } from './validation.types';

export const composeValidators =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (validators: ValidateType[]) => async (value: any, allValues?: any) => {
    for (const validator of validators) {
      const error = await validator?.(value, allValues);
      if (error) return error;
    }
    return undefined;
  };
